module.exports = __webpack_public_path__ + "11d270aad1dd2a05634a959e48737cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash-blue.png
// module id = 224
// module chunks = 0